function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 10082",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 15.967 17.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m641.214 372.44 1.978-1.223.386-.24H650a4 4 0 0 0 3.991-3.992v-3.193A4 4 0 0 0 650 359.8h-4.791a4 4 0 0 0-3.992 3.992v8.647m-1.6 2.865v-11.511a5.589 5.589 0 0 1 5.588-5.589H650a5.588 5.588 0 0 1 5.588 5.589v3.193a5.588 5.588 0 0 1-5.588 5.588h-5.965z",
    transform: "translate(-639.617 -358.204)",
    style: {
      fill: "#65676f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.647 365.8h-5.232a.8.8 0 0 1 0-1.6h5.232a.8.8 0 0 1 0 1.6z",
    transform: "translate(-640.827 -359.414)",
    style: {
      fill: "#65676f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.809 369.8h-2.4a.8.8 0 0 1 0-1.6h2.4a.8.8 0 0 1 0 1.6z",
    transform: "translate(-640.827 -360.221)",
    style: {
      fill: "#65676f"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d7e65084.svg";
export { ForwardRef as ReactComponent };